<template>
  <div class="flex box artist-container">
    <div class="instructions">
      <h1 class="m-t-0">Find some new tunes!</h1>
      <p>Check out this selection of your favorite artists. You can choose up to five artists to base you suggestion off of.</p>
    </div>
    <div v-wheel="handleScroll" class="artist-list flex s-a-start" ref="artistList">
      <div class="artist" @click="toggleSelectedStatus(artist)" :class="{selected: artist.selected}" v-for="(artist, index) in seedArtistList" :key="index">
        <h3 class="artist-name">{{artist.name}}</h3>
        <img class="artist-img" :src="artist.images[0].url" :alt="`Spotify cover-photo of the artist ${artist.name}`">
        <div class="artist-options flex m-a-start s-a-center">
          <button class="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="#fff" d="M11 9V5H9v4H5v2h4v4h2v-4h4V9h-4zm-1 11a10 10 0 1 1 0-20 10 10 0 0 1 0 20z"/></svg>
          </button>
        </div>
      </div>
    </div>
    <div class="mobile nav-buttons m-a-center s-a-center">
      <button class="backwards-scroll btn btn-secondary m-r-3" @click="buttonScroll('negative')">Backwards-Scroll</button>
      <button class="forwards-scroll btn btn-secondary" @click="buttonScroll('positive')">Forwards-Scroll</button>
    </div>
  </div>  
</template>

<script>
import {bus} from '../../main';
export default {
  name: 'artistList',
  props: ['artists'],
  data: () => {
    return {
      seedArtists: []
    }
  },
  methods: {
    buildSeedArtists(){
      this.seedArtists = this.seedArtistList
        .filter(artist => { return artist.selected })
        .map(artist => { return artist.id });
        bus.$emit('updateActionBar', this.seedArtists);
    },
    toggleSelectedStatus(artist) {
      if (!artist.selected && this.seedArtists.length === 5) {
        return bus.$emit('showModal', {
          headText: "Hol' up a minute",
          bodyText: "You can only define up to 5 seed artists",
          notificationType: 'error',
          autoDismiss: true
        });
      }

      artist.selected = !artist.selected;
      this.$forceUpdate();
      this.buildSeedArtists();
    },
    handleScroll: function (evt, el) {
      evt.preventDefault(); // We dont want a vertical scroll to happen on this element
      const scrollFactor = evt.deltaY > 0 ? 1 : -1;
      const totalScrollAmount = 250;
      
      let progress = 0;
      let scrollInterval = setInterval(() => {
        const scrollAmount = 10;
        el.scrollTo({
          top: 0,
          left: el.scrollLeft + scrollAmount * scrollFactor
        });
        progress += scrollAmount;
        if (progress >= totalScrollAmount) { clearInterval(scrollInterval) }
      }, 10)
    },
    buttonScroll (direction) {
      const exampleArtist = this.$refs.artistList.firstElementChild;
      const margin = 48; // there has to be a better way to do this
      const scrollOptions = {
        elementToScroll: this.$refs.artistList,
        totalScrollAmount: this.calculateArtistWidth(exampleArtist) + margin,
        scrollFactor: direction === 'positive' ? 1 : -1,
        scrollDuration: 300
      }
      this.customScroll(scrollOptions);
    },
    calculateArtistWidth (artist) {
      return artist.getBoundingClientRect().right - artist.getBoundingClientRect().left;
    },
    customScroll (scrollOptions) {
      const {elementToScroll, totalScrollAmount, scrollFactor, scrollDuration} = scrollOptions;
      
      const scrollIntervalTime = 10;
      const scrollIntervalIterations = scrollDuration / scrollIntervalTime;
      const scrollIncrement = Math.floor(totalScrollAmount / scrollIntervalIterations);
      const initialScroll = elementToScroll.scrollLeft;
      
      let progress = 0;
      let scrollInterval = setInterval(() => {
        progress += scrollIncrement;
        if (progress <= totalScrollAmount && progress + scrollIncrement > totalScrollAmount) {
          const scrollPossible = initialScroll + totalScrollAmount * scrollFactor;
          const scrollCurrent = elementToScroll.scrollLeft;
          const scrollToEnd = scrollFactor === 1 ? scrollPossible - scrollCurrent : scrollCurrent - scrollPossible;
          elementToScroll.scrollTo({
            top: 0,
            left: elementToScroll.scrollLeft + (scrollToEnd * scrollFactor)
          });
          return clearInterval(scrollInterval);
        }
        if (progress >= totalScrollAmount) {
          return clearInterval(scrollInterval);
        }
        elementToScroll.scrollTo({
          top: 0,
          left: elementToScroll.scrollLeft + (scrollIncrement * scrollFactor)
        });
      }, scrollIntervalTime)

    },
    handleReset () {
      this.seedArtistList.forEach(artist => {
        artist.selected = false;
      });
      this.seedArtists = [];
      this.$forceUpdate();
    }
  },
  computed: {
    seedArtistList() {
      if (!this.artists) { return; }
      return this.artists.map(artist => {
        artist.selected = false;
        return artist;
      });
    }
  },
  created() {
    bus.$on('resetRecs', this.handleReset);
  },
}
</script>

<style scoped>
.mobile.nav-buttons {
  display: none;
  width: 100%;
}
.artist-container {
  padding: 2rem;
  max-width: 100%;
}
.artist-list {
  width: 100%;
  flex-wrap: nowrap;
  overflow: hidden;
  padding-bottom: 2rem;
}
.artist {
  margin-right: 3rem;
  position: relative;
}
.artist:last-child {
  margin-right: 0;
}
.artist-name {
}
.artist-img {
  width: 320px;
  max-width: initial;
  height: 400px;
  object-fit: cover;
  border: 16px solid #fff;
  transition: border-color .2s ease;
}
.selected .artist-img {
  border-color: #454F8C;
}
.artist-options {
  position: absolute;
  bottom: .6rem;
  height: 30px;
  width: 100%;
  left: 0;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}
.button {
  padding: .8rem;
  background: linear-gradient(-45deg, #FF9E01, #fff2c0);
  box-shadow: 0px 0px 0px 3px rgba(255, 255, 255, 1), 0px 3px 12px 3px rgba(0,0,0,0.2), inset 0px 1px 2px 3px rgba(0,0,0,0.0);
  border-radius: 50%;
  border: none;
  opacity: 0;
  transform: rotateY(80deg) translateY(5px);
  transition: all .2s ease;
  transform-origin: 50% 30%;
  cursor: pointer;
}
.button > svg {
  transform: scale(1);
  transition: transform .4s ease;
}
.selected .button > svg {
  transform: scale(.8);
}

.artist:hover .button {
  transform: rotate(0deg) translateY(0px);
  opacity: 1;
}

.button:hover {
  box-shadow: 0px 0px 0px 3px rgba(255, 255, 255, 1), 0px 3px 12px 3px rgba(0,0,0,0.2), inset 0px 2px 3px 1px rgba(0,0,0,0.2);
}
.selected .button {
  box-shadow: 0px 0px 0px 3px rgba(255, 255, 255, 1), 0px 3px 12px 3px rgba(0,0,0,0.2), inset 0px 2px 3px 5px rgba(0,0,0,0.2);
}

@media screen and (max-width: 1024px){
  .mobile.nav-buttons {
    display: flex;
  }
}
</style>